import { render } from "./Roster_new.vue?vue&type=template&id=2ee1873d&scoped=true"
import script from "./Roster_new.vue?vue&type=script&lang=js"
export * from "./Roster_new.vue?vue&type=script&lang=js"

import "./Roster_new.vue?vue&type=style&index=0&id=2ee1873d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee1873d"]])

export default __exports__